import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { getDisciplineGroup, updateDisciplineGroup } from '../../../api/services/disciplineGroupService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
import { useParams } from 'react-router-dom';
import DisciplineGroup from '../../../api/models/disciplineGroup';

type Params = {
  id: string;
};

const fetchDisciplineGroup = async ({ id }: any) => {
  return await getDisciplineGroup(id);
};

const EditDisciplineGroup = () => {
  const { id } = useParams<Params>();
  const history = useHistory();

  const [name, setName] = useState('');
  //const [visible, setVisible] = useState(true);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const disciplineGroupData = useAsync({
    promiseFn: fetchDisciplineGroup,
    id,
    onResolve: (r: any) => {
      const disciplineGroup: DisciplineGroup = r.data.disciplineGroup;

      //Set the relevant data
      setName(disciplineGroup.name ?? '');
      //setVisible(disciplineGroup.isVisible);
    }
  });

  const saveDisciplineGroup = async () => {
    return await updateDisciplineGroup(Number(id), {
      name: name,
      isVisible: true
    });
  };

  const save = useAsync({
    deferFn: saveDisciplineGroup,
    onResolve: (r) => {
      history.push(`/admin/disciplines/groups`, {
        message: `"${name}" saved successfully!`,
      });
    },
  });

  return (
    <Fragment>
      <Layout>
        <Fragment>
          <ResponseStatus state={save} />
          <div>
            <div className='grid grid-cols-6 gap-6 mb-6'>
              {/*<div className='col-span-6 sm:col-span-6'>
                <div className='flex items-start'>
                  <div className='flex items-center h-5'>
                    <input
                      id='is-visible'
                      name='is-visible'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={visible}
                      onChange={(e) => setVisible(e.currentTarget.checked)}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='is-visible' className='primary'>
                      Active
                    </label>
                  </div>
                </div>
              </div>*/}
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='name'
                  label='Name'
                  minLength={1}
                  maxLength={50}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
            </div>
          </div>

          <hr className='py-4' />

          <div className='text-right'>
            <SubmitButton
              text='Save Changes'
              disabled={name.length === 0}
              spinning={save.isPending}
              onClick={() => { save.run() }}
            />
          </div>
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default EditDisciplineGroup;
